module.exports = __webpack_public_path__ + "static/media/higsystem-short-logo.8e53a8ff.svg";